{
  "buttons/add.Label": "Hinzufügen",
  "buttons/cancel.Label": "Abbrechen",
  "buttons/delete.Label": "Löschen",
  "buttons/create.Label": "Erstellen",
  "buttons/save.Label": "Speichern",
  "buttons/confirm.Label": "Bestätigen",
  "buttons/search.Label": "Suche",
  "buttons/continue.Label": "Weiter",
  "buttons/send.Label": "Senden",
  "buttons/close.Label": "Schließen",
  "buttons/back.Label": "Zurück",
  "labels/search.Label": "Suchen",
  "labels/pagination/showResults.Label": "Resultate anzeigen",
  "input/search.Placeholder": "Suchen Sie nach Ihrer Phrase",

  "titles/create-new.Label": "Neu erstellen",
  "titles/edit.Label": "Bearbeiten",
  "titles/image.Placeholder":  "Bild hinzufügen",
  "labels/tables.Loading": "Ergebnisse laden...",
  "labels/tables.NoResults": "Keine Ergebnisse",
  "labels/tables.MoreNoResults": "Es gibt keine Daten zur Vorschau.",
  "labels/tables.ChangePhrase": "Bitte ändern Sie den Suchbegriff.",
  "labels/tables.ResetFilters": "filter zurücksetzen",

  "forms/required.Label": "Pflichtfeld",

  "mandator/terminals/terminal/terminal-ots-qr/downloadModal.specificSeats.syntaxTooltip.Text": "Beispiele: 5/12 für Reihe 5 Platz 12, 12L/5 für Reihe 12L Platz 5, oder ein Reihen-Token für die ganze Reihe. Einträge mit Komma trennen.",
  "mandator/terminals/terminal/terminal-ots-qr/downloadModal.backToPreview.Label": "Fertig - zurück zur Vorschau",
  "mandator/terminals/terminal/terminal-ots-qr/downloadModal.seatMap.Label": "Sitze auf dem Sitzplan wählen",
  "mandator/terminals/terminal/terminal-ots-qr/downloadModal.seatMap.hint.Text": "Klicken Sie auf einen Sitz, um ihn hinzuzufügen oder zu entfernen · klicken Sie auf eine Reihennummer, um die ganze Reihe zu wählen"
}
